export var ReadingPaneDisplay;
(function (ReadingPaneDisplay) {
    ReadingPaneDisplay[ReadingPaneDisplay["Initial"] = 0] = "Initial";
    ReadingPaneDisplay[ReadingPaneDisplay["Default"] = 1] = "Default";
    ReadingPaneDisplay[ReadingPaneDisplay["Show"] = 2] = "Show";
    ReadingPaneDisplay[ReadingPaneDisplay["Hide"] = 3] = "Hide";
    ReadingPaneDisplay[ReadingPaneDisplay["AlwaysHide"] = 4] = "AlwaysHide";
})(ReadingPaneDisplay || (ReadingPaneDisplay = {}));
//# sourceMappingURL=PreviewPaneStore.js.map